import React, { useEffect } from "react";
import Datas from "../data/faq-event/faq-event.json";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/faqEvent.js";

function FaqEvent() {
  useEffect(() => {
    const accordionButton = document.querySelectorAll(".accordion-button");
    accordionButton.forEach((button) => {
      button.addEventListener("click", () => {
        button.classList.toggle("active");
        const content = button.nextElementSibling;

        if (button.classList.contains("active")) {
          content.className = "accordion-content show";
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          content.className = "accordion-content";
          content.style.maxHeight = "0";
        }
      });
    });
  }, []);

  // Split FAQ data into left and right halves
  const mid = Math.ceil(Datas.faqDataList.length / 2);
  const leftData = Datas.faqDataList.slice(0, mid);
  const rightData = Datas.faqDataList.slice(mid);

  return (
    <Styles>
      <section className="event-faq-area">
        <Container>
          {/* Section Title */}
          <Row>
            <Col md="12">
              <div className="sec-title">
                <h4>
                  Frequently Ask <span>Question</span>
                </h4>
              </div>
            </Col>
          </Row>

          <Row>
            {/* Left Column */}
            <Col md="6">
              <div className="faq-area">
                <div className="faq-box">
                  {leftData.map((faq, i) => (
                    <div className="faq-item" key={i}>
                      <button className="accordion-button active">
                        <div className="accordion-icon">
                          <i className="las la-plus"></i>
                        </div>
                        <p>{faq.faqTitle}</p>
                      </button>
                      <div className="accordion-content show">
                        <p>{faq.faqDesc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>

            {/* Right Column */}
            <Col md="6">
              <div className="faq-area">
                <div className="faq-box">
                  {rightData.map((faq, i) => (
                    <div className="faq-item" key={i}>
                      <button className="accordion-button active">
                        <div className="accordion-icon">
                          <i className="las la-plus"></i>
                        </div>
                        <p>{faq.faqTitle}</p>
                      </button>
                      <div className="accordion-content show">
                        <p>{faq.faqDesc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
}

export default FaqEvent;
